import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../shared/Button';
import Icon from '@showclix-shared/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { submitCoupon, validateCoupon } from '../../coupon/actions/coupon';
import { addAlert } from '../../../actions/ui';
import { useTranslation } from '../../../config/Translations';
import { CheckoutModal } from './CheckoutModal';

const CouponInputModalContent = ({ open, onClose }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const currentCode = useSelector((state) => state.coupon.code);
  const isCouponLoading = useSelector((state) => state.coupon.loading);
  const customPromoCodeText = useSelector((state) => state.ui.listingConfig?.custom_promo_code_text);

  const inputRef = useRef(null);

  const [code, setCode] = useState(currentCode);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateAndSubmit = async () => {
    const { valid, isPlCode } = await dispatch(validateCoupon({ code, submitAccessCoupon: false }));

    if (!valid) {
      dispatch(addAlert('checkout__invalid_coupon'));
      return;
    }

    // access code
    if (isPlCode) {
      dispatch(addAlert('checkout__can_not_apply_access_coupon'));
      return;
    }

    setIsSubmitting(true);
    const isSubmitted = await dispatch(submitCoupon());
    setIsSubmitting(false);

    if (!isSubmitted) {
      return;
    }

    dispatch(addAlert('checkout__success_submitting_coupon', 'success'));
  };

  const onApply = async () => {
    await validateAndSubmit();
    onClose?.();
  };

  const onCodeChange = (e) => {
    setCode(e.target.value);
  };

  const clearCode = () => setCode('');

  const canApply = code && code !== currentCode;

  return (
    <CheckoutModal
      open={open}
      onClose={onClose}
      backdrop
      focusTrapOptions={{
        initialFocus: () => inputRef.current,
      }}
    >
      <CheckoutModal.Header>
        <CheckoutModal.Title>{customPromoCodeText || t('checkout__promo_code')}</CheckoutModal.Title>
        <CheckoutModal.CloseButton disabled={isCouponLoading || isSubmitting} />
      </CheckoutModal.Header>
      <CheckoutModal.Body>
        <div className="inline-coupon__input-container">
          <input ref={inputRef} className="input__control" value={code} onChange={onCodeChange} />
          {code && (
            <Button className="button--clear inline-coupon__icon-button" onClick={clearCode}>
              <Icon icon="icon-close" color="#585858" alt="Clear coupon code" />
            </Button>
          )}
        </div>
      </CheckoutModal.Body>
      <CheckoutModal.Footer>
        <Button
          className="button--primary button--large button--full"
          onClick={onApply}
          loading={isCouponLoading || isSubmitting}
          disabled={!canApply}
        >
          {t('checkout__apply')}
        </Button>
      </CheckoutModal.Footer>
    </CheckoutModal>
  );
};

CouponInputModalContent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

const CouponInputModal = ({ open, onClose }) => {
  if (!open) {
    return null;
  }

  return <CouponInputModalContent open={open} onClose={onClose} />;
};

CouponInputModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default CouponInputModal;
